import React, { useCallback } from "react";
import Sidebar from "./Sidebar";
import { getPopoverByName } from "../../../utils";
import TextScript from "./script/TextScript";
import ChatGpt from "./script/ChatGpt";
import { selectSubTab } from "../../../store/common/uiSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import GenerateScript from "./script/GenerateScript";
import GenerateScriptWithAI from "./script/GenerateScriptWithAI";

const UseaiPopover = () => {
  const dispatch = useDispatch();
  // const onTabSelect = () => {};
  const trial = useSelector((state) => state?.user?.details?.data?.trial);

  const thisPopover = getPopoverByName("UseAI", trial);

  const { subTab } = useSelector((state) => state.ui);
  const { slides, currentSlideIndex } = useSelector((state) => state.slides);
  const { generateScriptModal, generateScriptWithAIModal } = useSelector(
    (state) => state.script
  );
  console.log("generateScriptModal", generateScriptModal);
  const onTabSelect = useCallback(
    (tabIndex) => {
      dispatch(selectSubTab(tabIndex));
    },
    [dispatch]
  );

  // const shouldDisplayOneSlide = slides[0]?.objects?.some((slide) => {
  //   // Check if the slide is an avatar and its URL includes "d-id"
  //   if (slide.type === "avatar" && slide.url.includes("d-id")) {
  //     // Optional: Logging the matching slide
  //     return true; // Return true if the slide matches the criteria
  //   }
  //   return false; // Return false otherwise
  // });
  const slidesWithAvatarDId = slides.filter((slide) => {
    // Check if the slide has objects and any of them is an avatar with a URL including "d-id"
    return (
      slide.objects &&
      slide.objects.some((obj) => {
        return obj.type === "avatar" && obj.url.includes("d-id");
      })
    );
  });

  const shouldDisplayOneSlide = slidesWithAvatarDId.length >= 3;

  return (
    <div className="flex w-full h-full overflow-auto">
      {generateScriptModal ? (
        <GenerateScript />
      ) : (
        <>
          <Sidebar
            titleIcon={"/tool/dashboard/static/images/icons/tools/script.svg"}
            title={"UseAI"}
            tabs={thisPopover.tabs}
            onTabSelect={onTabSelect}
            isDisabled={shouldDisplayOneSlide}
          />
          <div className="px-2 py-4 w-4/5 bg-gray-100">
            {/* {subTab === 0 && <TextScript />} */}
            {/* {subTab === 2 && !generateScriptWithAIModal && <ChatGpt />} */}
            {!shouldDisplayOneSlide ? (
              <GenerateScriptWithAI />
            ) : (
              <p>
                In order to ensure stability of the vidBoard tool, we are not
                allowing ChatGpt while using Pro Avatar. This restriction will
                be lifted in a few days. Please be rest assured.{" "}
              </p>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default UseaiPopover;
